const cache = {
    section: null,
    container: null,
    items: null,
    spaces: null
};

function initCache() {
    cache.section = document.querySelector('[data-timeline-section]');
    cache.container = document.querySelector('[data-timeline-items]');
    if (cache.container) {
        cache.items = cache.container.querySelectorAll('[data-timeline-item]');
        cache.spaces = cache.container.querySelectorAll('[data-timeline-space]');
    }
}

function setSubTimelineHeight() {
    if (!cache.container || !cache.items?.length || !cache.spaces?.length) return;

    const isMobile = window.innerWidth <= 767;
    let maxHeight = 0;

    for (let i = 0; i < cache.spaces.length; i++) {
        const space = cache.spaces[i];
        const attr = isMobile ? 'mobileH' : 'desktopH';
        const dataHeight = parseInt(space.dataset[attr], 10) || 0;
        const itemHeight = cache.items[i]?.offsetHeight || 0;
        const total = dataHeight + itemHeight + 16;
        if (total > maxHeight) maxHeight = total;
    }

    cache.container.style.minHeight = `${maxHeight}px`;
}

function observeSubTimeline() {
    if (!cache.section) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('js-animated');
                } else if (entry.boundingClientRect.top > 0) {
                    entry.target.classList.remove('js-animated');
                }
            });
        },
        {
            threshold: 0,
            rootMargin: '0px 0px -30% 0px'
        }
    );

    observer.observe(cache.section);
}

let resizeTimer;
function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setSubTimelineHeight, 150);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initCache();
        setSubTimelineHeight();
        observeSubTimeline();
    });
} else {
    initCache();
    setSubTimelineHeight();
    observeSubTimeline();
}

window.addEventListener('resize', handleResize, { passive: true });
